import React from "react";
import Svg, { G, Path } from "react-native-svg";

type Avatar30Colors = {
  background?: string;
  hair?: string;
  skin?: string;
  accessories?: string;
};

export const Avatar30 = ({
  colors = {},
  size = 96,
}: {
  colors?: Avatar30Colors;
  size?: number | string;
}) => {
  const c = {
    background: colors.background ?? "#fff",
    hair: colors.hair ?? "#fff",
    skin: colors.skin ?? "#fff",
    accessories: colors.accessories ?? "#fff",
  };
  return (
    <Svg width={size} height={size} viewBox="0 0 304 304" fill="none">
      <G id="avatar30">
        <Path
          id="background"
          d="M151.833 303.667c83.856 0 151.834-67.978 151.834-151.834C303.667 67.978 235.689 0 151.833 0 67.978 0 0 67.978 0 151.833c0 83.856 67.978 151.834 151.833 151.834Z"
          fill={c.background}
        />
        <Path
          id="Vector"
          d="M151.833 303.667c34.642 0 66.567-11.613 92.122-31.139-5.402-8.881-11.916-17.118-19.105-21.241-15.053-8.642-78.26-17.277-128.844-15.895-26.071.707-43.269 9.493-54.62 20.622 27.683 29.343 66.924 47.669 110.455 47.669l-.008-.016Z"
          fill="#000"
        />
        <G id="Group">
          <Path
            id="hair"
            d="M96.26 154.621s.572 11.669 8.229 21.416c7.658 9.747 9.715 7.284 9.715 7.284l-1.159-19.311-16.785-9.389Z"
            fill={c.hair}
          />
          <Path
            id="skin"
            d="M222.427 160.968c2.169-11.764-1.302-16.864-1.302-32.013 5.592-39.781-1.946-79.062-42.721-79.062-73.613 0-80.984 19.605-80.984 65.511 0 2.391-.413 1.501-.191 3.971-11.4 2.606-13.687 13.203-10.629 22.401 7.166 21.551 24.077 24.959 24.411 24.776 2.78 6.347-2.502 45.62-4.345 52.897-2.979 11.748-10.676 15.942-10.676 15.942s39.813 29.209 70.364 26.444c10.176 0 27.54-14.862 6.283-21.503-3.392-1.056-.437-18.405.302-30.98 6.506 1.7 17.508 6.728 27.381-3.511 4.377-10.39 15.324-31.782 22.107-44.865v-.008Z"
            fill={c.skin}
          />
          <Path
            id="Vector_2"
            d="M136.804 115.881s12.837-3.916 22.814-3.845c11.724.079 19.962 7.705 22.218 3.805.715-1.239.23-7.761-21.146-9.898-9.564-.953-15.188 3.4-23.886 9.938Z"
            fill="#000"
          />
          <Path
            id="Vector_3"
            d="M178.532 132.467c-2.892-4.798-7.69-9.223-13.703-10.295-2.709-.31-5.457-.008-8.039.961-2.113.787-3.733 2.081-5.298 3.376-2.121 1.422-4.933.882-7.483.596 2.407 1.636 5.973 2.947 8.905 1.541a24.75 24.75 0 0 1 2.041-1.152c-.024.207-.04.413-.04.62 0 3.821 3.297 6.911 7.364 6.911s7.364-3.098 7.364-6.911c0-.31-.032-.62-.072-.922 2.884 1.287 5.783 3.194 8.968 5.283l-.007-.008Z"
            fill="#000"
          />
          <Path
            id="Vector_4"
            opacity={0.75}
            d="M200.353 118.192c-.278-.381-.27-1.017.087-1.763-10.056 14.012 3.837 36.556-1.581 40.814-3.781 2.971-18.087-1.184-18.643 2.621 5.203 3.193 19.549 5.743 23.894-1.644 1.7-3.813-9.54-29.177 1.605-40.036-2.113 1.462-4.417 1.303-5.346.016l-.016-.008Z"
            fill="#2E2017"
          />
          <Path
            id="Vector_5"
            opacity={0.75}
            d="M140.442 209.662c14.108 11.995 22.147 15.649 31.25 16.602-.167-7.03 1.644-16.776 1.247-16.911-20.065-6.903-28.803-13.218-45.088-27.183-5.934-5.084-11.264-12.432-15.847-19.136 0 .445.063.969 0 2.605 2.28 9.906 8.952 27.469 28.438 44.039v-.016Z"
            fill="#2E2017"
          />
          <Path
            id="Vector_6"
            opacity={0.75}
            d="M165.004 173.122c.874.738 13.059 14.195 26.714 13.702 11.63-.413 15.395-11.486 15.673-12.05 0 0-5.14-4.774-8.714-4.647-3.575.127-6.069 1.843-6.069 1.843s-3.217-1.867-7.014-1.732-7.181 2.066-10.732 2.637c-3.591.588-9.858.247-9.858.247Zm4.917 2.152c-.095-.047-.008-.158.103-.119 4.353 1.518 11.9 2.55 23.585 2.129 6.021-.214 10.009-.405 13.305-1.469-3.288 1.318-7.618 4.869-13.631 5.083-11.725.421-19.057-3.376-23.362-5.624Z"
            fill="#2E2017"
          />
          <Path
            id="Vector_7"
            d="M222.467 108.247c-14.02-.405-23.624 7.141-22.115 9.945.93 1.732 3.789 1.811 5.902-.151 5.783-4.822 10.271-3.209 16.332-3.289.135-1.993-.095-4.845-.119-6.505Z"
            fill="#000"
          />
          <Path
            id="Vector_8"
            d="M227.94 127.168c-1.565-1.294-3.185-2.597-5.298-3.376-2.582-.969-5.322-1.271-8.039-.961-6.021 1.073-10.811 5.497-13.703 10.295 1.637-1.072 3.202-2.097 4.719-3.019.278 3.361 3.265 5.998 6.911 5.998 3.837 0 6.942-2.915 6.942-6.522 0-1.223-.381-2.351-1-3.328 2.486.27 5.115 1.207 8.046 3.042 2.924 1.406 6.49.096 8.897-1.541-2.55.286-5.362.834-7.483-.596l.008.008Z"
            fill="#000"
          />
          <Path
            id="hair_2"
            d="M139.274 78.196s7.436 13.695-1.763 24.641c-9.191 10.954-11.542 10.756-11.733 17.015-.198 6.26-1.763 19.947-1.763 19.947l-6.848-.199s-11.343-21.71-23.076-15.45c-11.732 6.259-7.856 16.228-7.856 16.228s-9.945-21.312-10.922-29.137l-2.74 4.894s-4.497-26.016 3.129-38.725l-6.148 8.515s.254-13.639 10.874-23.425C91.05 52.713 97.254 51.33 97.254 51.33l-8.69.691s9.723-16.459 25.03-16.014c19.581-6.53 26.555-11.256 47.264-8.555 20.709 2.7 47.487 18.683 56.495 32.862 9 14.18 7.205 18.906 7.205 18.906s4.559 8.023 3.884 15.704c-.683 7.682-6.657 15.196-6.657 15.196s-1.366-21.344-4.265-25.784c-.167 3.582.683 10.072.683 10.072l-8.54-15.196-.85 18.27S197.199 84.17 190.717 82.97c5.973 7.856 6.998 17.071 6.998 17.071s-23.735-18.612-31.583-21.17c-7.857-2.557-13.655-1.366-13.655-1.366l21.511 16.388s-30.456-4.449-34.69-15.713l-.024.016Z"
            fill={c.hair}
          />
          <Path
            id="accessories"
            d="M110.654 168.737a6.557 6.557 0 0 0 6.553-6.561 6.558 6.558 0 0 0-6.553-6.562 6.558 6.558 0 0 0-6.553 6.562 6.557 6.557 0 0 0 6.553 6.561Z"
            fill={c.accessories}
          />
        </G>
      </G>
    </Svg>
  );
};
